import { ShareEntityType } from '@utils/shareConfig';
import { shareContent } from '@utils/shareHelpers';
import { logger } from '@utils/logger';
import { liveLink } from './liveLinks';

/**
 * A live poll is shared by its author alone (founder, 3 Nov; reverses TECH-867 § Decided "Share stays on the live
 * poll card"), in every state and on every surface. Someone in the room has no Share, and the ordinary post share
 * sheet is no fallback: a post link on a live poll gets a non-member a 404.
 */
export const isLiveShareHidden = (question: {
  poll?: { mode: string } | null;
  is_my_question?: boolean | null;
}): boolean => question.poll?.mode === 'live' && !question.is_my_question;

/**
 * The author's Share on a started live poll: the live link, so whoever opens it gets what the room gets. The
 * system share sheet on native and where the browser has one, else the link is copied (`shareContent`).
 */
export const shareLiveLink = (code: string, text: string): void => {
  shareContent(text, liveLink(code), ShareEntityType.Question).catch((error: unknown) => {
    logger.warn('[live-poll] share failed', error);
  });
};
